export const ACTIVE_TAB = 'activeUsers';
export const PENDING_TAB = 'pendingUsers';

